import * as React from "react";
import ReactPaginate from "react-paginate";

import {
    IconChevronLeft,
    IconChevronRight,
} from "@common/components/Atoms/Icons";
import { GlobalConfig } from "@common/utils/config";

/*===========================================================================
  Pagination
/*======================================================================== */
interface PaginationProps {
    currentPage: number;
    pageSize: number;
    total: number;
    onPageChange: (selectedItem: { selected: number }) => void;
}

export const Pagination = (props: PaginationProps) => (
    <div className="c-pagination" data-cy="general-list-paginator">
        <ReactPaginate
            pageCount={Math.ceil(props.total / props.pageSize)}
            pageRangeDisplayed={GlobalConfig.ui.paginationPageRangeDisplayed}
            marginPagesDisplayed={
                GlobalConfig.ui.paginationMarginPagesDisplayed
            }
            initialPage={props.currentPage - 1}
            forcePage={props.currentPage - 1}
            previousLabel={<IconChevronLeft />}
            nextLabel={<IconChevronRight />}
            onPageChange={props.onPageChange}
            disableInitialCallback={true}
            containerClassName="c-pagination__container"
            pageClassName="c-pagination__page"
            pageLinkClassName="c-pagination__link"
            breakClassName="c-pagination__break"
            activeClassName="is-active"
            previousClassName="c-pagination__previous"
            nextClassName="c-pagination__next"
            previousLinkClassName="c-pagination__previous-link"
            nextLinkClassName="c-pagination__next-link"
            disabledClassName="is-disabled"
        />
    </div>
);

export default Pagination;
